// CMP-Skeleton (Lot 1b ; ETAT-01). Séparé de Feedback : les états de chargement font partie du JS initial, les toasts
// (sonner) non.
import { cn } from '@/lib/cn';

/** CMP-Skeleton : formes du contenu final ; aria-busy porté par le conteneur appelant. */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-surface-2', className)} />;
}
